import { toast } from "react-toastify";
import { i18n } from "../translate/i18n";

const toastError = err => {
	const errorMsg = (err.response?.data?.message || err.response?.data?.error || "").trim();
	
  if (errorMsg) {
    const translationKey = "backendErrors." + errorMsg;
        
		if (i18n.exists(translationKey)) {
			toast.error(i18n.t(translationKey), {
				toastId: errorMsg,
			});
		} else {
			toast.error(errorMsg, {
				toastId: errorMsg,
			});
		}
	} else {
    const fallbackMsg = err.message || "Ocurrió un error inesperado";
		toast.error(fallbackMsg);
		console.error(err);
	}
};

export const toastSuccess = (data, successMessage) => {
  if (data && data.messageError) {
    toast.warn(data.messageError, { 
      autoClose: 10000 
    });
  } else {
    toast.success(successMessage || "Operación exitosa");
  }
};

export default toastError;